export enum EntryType {
  Individual = 1,
  Team = 2,
}

export enum LocationEnum {
  Virtual = 1,
  Brisbane,
}

export enum StreamEnum {
  Women = 1,
  Indigenous,
  Gaming,
}

export type RegisterPayload = {
  agreeReceiveEmail: boolean;
  campaignSubscribe: number; // this describes the subscription to Hackathon 2022
  email: string;
  entryType: number;
  name: string;
  organisation: string;
  recaptchaResponse: string;
  stream: number[];
  comment?: string;
  components?: Object;
  fingerprint?: string;
  location: number;
  phone?: string;
  preferName?: string;
  ref?: string;
  teamName?: string;
};

export type RegisterFormErrors = {
  phone: string;
  email: string;
  entryType: string;
  name: string;
  location: string;
  organisation: string;
};

export type RegisterUserResponse = {
  error?: string;
  msg?: string;
  subscribe_ref?: string;
};

// Order represents order in navigation buttons - DO NOT CHANGE
export enum NavMenuEnum {
  Home = "Home",
  Event = "Event Information",
  ChallengesPrizes = "Prizes",
  Guests = "Guest Speakers",
  Partners = "Partners",
  Faq = "FAQ",
  Contact = "Contact Us",
}

export enum RoutingIDEnum {
  TopAnchor = "page-top",
  Home = "",
  Event = "event-information",
  ChallengesPrizes = "challenges-prizes",
  Guests = "guest-speakers",
  Partners = "partners",
  Faq = "faq",
  Contact = "contact-us",
}

export enum RoutingAnchorEnum {
  TopAnchor = "#page-top",
  Home = "/",
  Event = "#event-information",
  ChallengesPrizes = "#challenges-prizes",
  Guests = "#guest-speakers",
  Partners = "#partners",
  Faq = "#faq",
  Contact = "#contact-us",
}

export enum RoutesEnum {
  Home = "/",
  Nav = "/nav",
  Register = "/register",
  Verify = "/verify/:ref",
}

export type SectionPageTitleProps = {
  title: string;
  color?: string;
  style?: Object;
};

export type SectionPageIntroProps = {
  text: string;
  style?: Object;
};

export type CardFlipProps = {
  partner?: Partner;
  speaker?: Speaker;
  sectionBackGroundColor: string;
};

export type PartnersSectionProps = {
  sectionBackGroundColor: string;
};

export type PartnerItemProps = {
  partner: Partner;
};

export type Partner = {
  name: string;
  about: string;
  link: string;
  image: string;
  level?: number;
  invertLogoColor?: boolean;
  bgColor?: string;
};

export type GuestSpeakersSectionProps = {
  sectionBackGroundColor: string;
};

export type SpeakerItemProps = {
  speaker: Speaker;
};

export type Speaker = {
  name: string;
  representing: string;
  about: string;
  image: string;
  link?: string;
  invertLogoColor?: boolean;
  bgColor?: string;
};

export type ConfirmModalTextProps = {
  title: string;
  message: string;
  confirmButton: string;
  cancelButton?: string;
};

export type ConfirmModalProps = {
  confirmModal: boolean;
  closeConfirmModal: () => void;
  openConfirmModal: Function;
  confirmModalText?: ConfirmModalTextProps;
};

export enum RegisterResponses {
  AlreadyUnsubscribed = "already unsubscribed",
  CaptchaError = "captcha",
  FormError = "invalid fields",
  NotFound = "not found",
  PrivacyError = "privacy",
  RegisterError = "submit error",
  Success = "success",
  VerifyCaptchaError = "invalid captcha",
}

export enum ModalTitles {
  DefaultError = "Oh snap!",
  Success = "Success!",
}

export enum ModalMessages {
  CaptchaError = "We were unable to verify your form. Please refresh the page and try again. Otherwise please email hackathon@entaingroup.com.au with your details and we will register you.",
  DefaultError = "Please refresh the page and try again. Otherwise email hackathon@entaingroup.com.au with your details and we will register you.",
  FormError = "Please correct the errors on the form before proceeding.",
  PrivacyError = "Please read and accept the privacy policy.",
  RegisterError = "We were unable to submit this application. Please email hackathon@entaingroup.com.au with your details and we will register you.",
  Success = "Thank you for registering. We will be in touch via email with more information.",
}

export enum VerifyResponses {
  Error = "",
  NotFound = "not found",
  Expired = "verify expired",
  Success = "verify successful",
  AlreadyVerified = "already verified",
}

export enum VerifyMessages {
  Loading = "We are checking your verification code...",
  Error = "Your reference code could not be verified. An error has ocurred, it has either expired, or something went wrong. Please register again to receive another verification email.",
  Success = "Your email address has been verified. Thank you for registering.",
}
